module.exports = __webpack_public_path__ + "static/media/workout-cross-link.12801f24.png";